import api from "../../../utils/api";

export const createMailbox = async (payload) => {
  if (process.env.NODE_ENV === "development") console.log(payload);
  const res = await api.post("/mailboxes/", payload);
  return res.data;
};

export const readMailbox = async (publicId) => {
  if (!publicId) throw new Error("Missing or invalid ID for mailbox");
  const res = await api.get(`/mailboxes/${publicId}`);
  return res.data;
};

export const readMailboxes = async () => {
  const res = await api.get("/mailboxes");
  return res.data;
};

export const updateMailbox = async (payload) => {
  if (process.env.NODE_ENV === "development") console.log(payload);
  if (!payload.public_id) throw new Error("Missing or invalid ID for mailbox");
  const res = await api.put(`/mailboxes/${payload.public_id}`, payload);
  return res.data;
};

export const deleteMailbox = async (publicId) => {
  if (process.env.NODE_ENV === "development") console.log(publicId);
  if (!publicId) throw new Error("Invalid ID for mailbox!");
  return await api.delete(`/mailboxes/${publicId}`);
};

export const startMonitor = async (publicId) => {
  if (!publicId) throw new Error("Invalid ID for mailbox!");
  const res = await api.post(`/mailboxes/${publicId}/start-monitor`);
  return res.data; // Return updated mailbox data with status
};

export const stopMonitor = async (publicId) => {
  if (!publicId) throw new Error("Invalid ID for mailbox!");
  const res = await api.post(`/mailboxes/${publicId}/stop-monitor`);
  return res.data; // Return updated mailbox data with status
};
